import Vue from 'vue'
import HTTP from '@/http-common.js'
import updateObject from '@/components/mixins/UpdateObject.js'

const state = {
  searchParams: {
    types: [],
    lang: null,
    offset: 0,
    limit: 10,
    order_by: 'alphabetical',
    order_dir: 'asc',
    is_backend: true,
  },
  list: [],
  countries: [],
  search: {
    tags: [],
    count: [],
  },
  loading: false,
}

const mutations = {
  setTags(state, tags) {
    state.list = tags
  },
  setSearchedTags(state, { tags, searchParams }) {
    state.search = tags
    state.searchParams = searchParams
  },
  setCountries(state, tags) {
    state.countries = tags
  },
  setSingleTag(state, { item, method }) {
    if (state.searchParams.types.includes(item.type) || state.searchParams.types.length === 0) {
      if (method === 'create') {
        state.search.tags.unshift(item)
        state.search.tags.pop()
      } else {
        const index = state.search.tags.findIndex((x) => x.id === item.id)

        if (index !== -1) {
          Vue.set(state.search.tags, index, item)
        }
      }
    }
  },
  setTagsLoading(state, val) {
    state.loading = val
  },
  deleteTags(state, tags) {
    state.search.tags = state.search.tags.filter((tag) => !tags.includes(tag.id))
  },
}

const actions = {
  loadTags({ commit, rootState }) {
    HTTP.get(`list_tags?lang=${rootState.ui.lang}`)
      .then((response) => {
        commit('setTags', response.data)
      })
      .catch((e) => {
        console.error(e)
      })
  },
  async loadCountries({ commit, rootState }) {
    await HTTP.post(`search/tag`, {
      types: ['country'],
      lang: rootState.ui.lang,
    })
      .then((response) => {
        commit('setCountries', response.data)
      })
      .catch((e) => {
        console.error(e)
      })
  },
  async searchTags({ commit, state, rootState }, obj) {
    commit('setTagsLoading', true)

    let body = JSON.parse(JSON.stringify(state.searchParams))
    if (!body.lang) body.lang = rootState.ui.lang
    if (obj) updateObject(obj, body)

    await HTTP.post(`search/tag`, body)
      .then((response) => {
        commit('setSearchedTags', { tags: response.data, searchParams: body })
        commit('setTagsLoading', false)
      })
      .catch((e) => {
        console.error(e)
        commit('setTagsLoading', false)
      })
  },
  updateTag({ commit }, { item, method }) {
    commit('setSingleTag', { item, method })
  },
  deleteTags({ commit }, tags) {
    commit('deleteTags', tags)
  },
}

export default {
  state,
  actions,
  mutations,
}
